import type { BookingStatus } from "./types";

export function statusLabel(s: BookingStatus): string {
  switch (s) {
    case "scheduled": return "Scheduled";
    case "ready": return "Ready";
    case "dispatched": return "Taxi";
    case "airborne": return "Airborne";
    case "in-progress": return "Airborne";
    case "returned": return "Returned";
    case "closed": return "Closed";
    case "completed": return "Completed";
    case "canceled": return "Canceled";
  }
}
